import { InvoiceLineItem } from "@portal/types/entities/invoice";
import { GridColumnProps } from "@sinecycle/growcomponents";
import { sum } from "lodash";
import { useMemo } from "react";

function useColumns() {
  function handleColumns() {
    const columns: GridColumnProps<InvoiceLineItem> = [
      {
        colId: "Item#",
        headerName: "Item #",
        valueGetter: (params) => {
          return sum([params.node?.rowIndex, 1]);
        },
      },
      {
        colId: "Title",
        headerName: "Title",
        field: "product_name",
        cellRenderer: "textCell",
        cellRendererParams: {
          textCellProps: {
            ellipsis: {
              tooltip: {
                placement: "left",
              },
            },
          },
        },
      },
      {
        colId: "Quantity",
        headerName: "Quantity",
        cellRenderer: "textCell",
        field: "quantity",
        cellClass: "ag-right-aligned-cell",
        headerClass: "ag-right-aligned-header",
      },
      {
        colId: "UnitPrice",
        headerName: "Unit Price",
        cellRenderer: "amountCell",
        field: "unit_price",
        cellClass: "ag-right-aligned-cell",
        headerClass: "ag-right-aligned-header",
        valueGetter: (params) => {
          return {
            amount: params?.data?.unit_price,
            currency: params?.data?.currency,
          };
        },
      },
      {
        colId: "TOTAL_AMOUNT",
        headerName: "Total Amount",
        cellRenderer: "amountCell",
        field: "amount",
        cellClass: "ag-right-aligned-cell",
        headerClass: "ag-right-aligned-header",
        valueGetter: (params) => {
          return {
            amount: params?.data?.amount,
            currency: params?.data?.currency,
          };
        },
      },
    ];

    return columns;
  }
  const colConfigs = useMemo(handleColumns, []);
  return { colConfigs };
}

export { useColumns };
